import * as R from "ramda";
import { connect } from "react-redux";
import React, { useState } from "react";
import { Button, Icon, message } from "antd";

import { Space } from "@/components/Space";
import { addTagApi } from "@/containers/Video/aliyun-service-api";
import { Prompt } from "@/containers/Video/widgets/create-project";
import { DrawerOfVideoTemplateJob } from "@/containers/Video/tab-pages/video-template-job";

/**
 * [FilterIcon   筛选 Arrow Down|Up]        [Gear 标签管理]
 * @param props
 * @constructor
 */
export const FilterRowController = connect((state) => ({
  ...state,
}))((props) => {
  const [openStatus, setOpenStatus] = useState(false);
  const orderId = R.pathOr(0, ["orderId"], props) * 1;
  const userId = R.pathOr("", ["user", "id"], props) * 1;
  const refreshTagList = R.pathOr(R.T, ["refreshTagList"], props);
  const refreshList = R.pathOr(R.T, ["refreshList"], props);
  //  选中了AI视频
  const isSelect09 = R.pathEq("0-9", ["selectedKeys", 0], props);
  return (
    <div>
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
        }}
      >
        <Space
          size="small"
          className="color-link cursor-pointer"
          onClick={() => {
            setOpenStatus(!openStatus);
          }}
        >
          <Icon type="filter" />
          <a>筛选</a>
          <Icon type={openStatus ? "up" : "down"} />
        </Space>

        <div className="flex flex-y-center">
          <Button onClick={refreshList}>刷新列表</Button>
          <div className="mr-2" />
          <Space
            onClick={() => {
              Prompt({
                title: "新建标签",
                placeholder: "请输入标签名称",
              }).then((tagName) => {
                addTagApi(orderId, tagName, userId).then(() => {
                  message.success("新建成功");
                  refreshTagList();
                });
              });
            }}
            size="small"
            className="color-link cursor-pointer"
          >
            <Icon type="setting" />
            <a>标签管理</a>
          </Space>
          {isSelect09 && (
            <DrawerOfVideoTemplateJob {...props}>
              {({ open }) => {
                return (
                  <Button
                    onClick={() => {
                      open();
                    }}
                    className="ml-2"
                  >
                    合成任务
                  </Button>
                );
              }}
            </DrawerOfVideoTemplateJob>
          )}
        </div>
      </div>
      <div
        className="pt-2"
        style={{
          display: openStatus ? "block" : "none",
        }}
      >
        {props.children}
      </div>
    </div>
  );
});



// WEBPACK FOOTER //
// ./src/containers/Video/widgets/filter-row-controller.js